module.exports = __webpack_public_path__ + "img/vaccine.b2b63eaa.svg";